import React from "react";
import { useFormContext } from "react-hook-form";
import { Dialog, Form } from "@sscs/ui";
import {
  LinkNameUseCase,
  SharedReportLinkNameForm,
  USE_CASE_LABEL,
} from "../../../../../types";
import { LINK_NAME_LABEL } from "../../../../../utils";
import styles from "./linkNameStep.module.scss";

const LinkNameStep = (): React.JSX.Element => {
  const formMethods = useFormContext<SharedReportLinkNameForm>();

  const { formState, setValue, trigger } = formMethods;

  return (
    <Dialog.Section>
      <Dialog.Section.Description>
        Complete the next steps to <strong>generate a link</strong> for sharing
        the analysis report with anyone{" "}
        <strong>inside or outside your organization.</strong> Report sharing
        settings can be <strong>customized per recipient.</strong>
      </Dialog.Section.Description>
      <Dialog.Section.Content>
        <Form.RadioGroup
          id="use_case"
          name="use_case"
          label="Select the use-case to generate link name"
          orientation="vertical"
          items={Object.entries(USE_CASE_LABEL).map(
            ([useCase, useCaseLabel]) => ({
              id: useCase,
              value: useCase,
              label: useCaseLabel,
            }),
          )}
          radioGroupClassName={styles["form-radio-group-vertical"]}
          onChange={(event) => {
            setValue(
              "label",
              LINK_NAME_LABEL[event.target.value as LinkNameUseCase],
            );
            trigger("label");
          }}
        />
        <Form.TextField
          label="Generated report link name"
          name="label"
          id="label"
          errors={formState.errors}
          isRequired
          isFullWidth
          placeholder="Generated report link name"
        />
      </Dialog.Section.Content>
    </Dialog.Section>
  );
};

export default LinkNameStep;
